import { render, staticRenderFns } from "./operacionesInformacionGeneral.vue?vue&type=template&id=d054d186"
import script from "./operacionesInformacionGeneral.vue?vue&type=script&lang=js"
export * from "./operacionesInformacionGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports